export const INBOX_V2_BOARD_ROOT_PATH = "/dashboard/inbox-v2";
export const INBOX_V2_TEMPORARY_BOARD_PATH =
  "/dashboard/inbox-v2/temporary-board";
export const INBOX_V2_CONVERSATION_PATH_PREFIX =
  "/dashboard/inbox-v2/conversation";
export const INBOX_V2_REPLY_TEMPLATES_PATH =
  "/dashboard/inbox-v2/reply-templates";
export const INBOX_V2_TAGS_PATH = "/dashboard/inbox-v2/tags";

export function getInboxV2BoardPath(boardId: string) {
  return `${INBOX_V2_BOARD_ROOT_PATH}/board/${encodeURIComponent(boardId)}`;
}

export function getInboxV2ConversationPath(conversationId: string) {
  return `${INBOX_V2_CONVERSATION_PATH_PREFIX}/${encodeURIComponent(conversationId)}`;
}

export function getInboxV2BoardIdFromPath(path: string) {
  const match = path.match(/^\/dashboard\/inbox-v2\/board\/([^/?#]+)/);

  return match ? decodeURIComponent(match[1]) : undefined;
}

export function isInboxV2PinnedBoardPathActive(path: string, boardId: string) {
  return getInboxV2BoardIdFromPath(path) === boardId;
}

export function isInboxV2BoardSubmenuPathActive(
  path: string,
  pinnedBoardIds: ReadonlySet<string>
) {
  if (
    path.includes(INBOX_V2_REPLY_TEMPLATES_PATH) ||
    path.includes(INBOX_V2_TAGS_PATH)
  ) {
    return false;
  }

  const boardId = getInboxV2BoardIdFromPath(path);

  return (
    path === INBOX_V2_BOARD_ROOT_PATH ||
    (path.includes(`${INBOX_V2_BOARD_ROOT_PATH}/board/`) &&
      (!boardId || !pinnedBoardIds.has(boardId)))
  );
}
